import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useQuery } from 'convex/react';
import { api } from '@/lib/api';
import type { Id } from 'convex/_generated/dataModel';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Icons } from '@/components/ui/icons';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { RatgeberPostForm } from '@/components/features/operator/blog/ratgeber-post-form';

const OperatorBlogPostPage = () => {
  const { t } = useTranslation('operator');
  const { postId } = Route.useParams();
  const navigate = useNavigate();
  const isNew = postId === 'new';

  const post = useQuery(api.app.ratgeberQueries.getRatgeberPost, isNew ? 'skip' : { postId: postId as Id<'ratgeberPosts'> });

  const isLoading = !isNew && post === undefined;

  return (
    <div className='container mx-auto py-8 space-y-6'>
      <div className='space-y-1'>
        <Link to='/operators/blog'>
          <Button variant='ghost' size='sm'>
            <Icons.ChevronLeft className='size-4 mr-1' />
            {t('blog.actions.back')}
          </Button>
        </Link>
        <h1 className='text-3xl font-bold tracking-tight'>{isNew ? t('blog.form.createTitle') : t('blog.form.editTitle')}</h1>
      </div>

      {isNew ? (
        <RatgeberPostForm mode='create' />
      ) : isLoading ? (
        <div className='space-y-4'>
          <Skeleton className='h-40 w-full' />
          <Skeleton className='h-40 w-full' />
        </div>
      ) : post ? (
        <RatgeberPostForm mode='edit' post={post} />
      ) : (
        <Card>
          <CardContent className='py-16 text-center'>
            <Icons.AlertCircle className='size-12 text-destructive mx-auto mb-3' />
            <p className='text-muted-foreground'>{t('blog.form.notFound')}</p>
            <Button variant='outline' className='mt-4' onClick={() => navigate({ to: '/operators/blog' })}>
              {t('blog.actions.back')}
            </Button>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export const Route = createFileRoute('/_protected/operators/blog/$postId')({
  component: OperatorBlogPostPage,
});
